angular.module("manager").factory("DepositAreaService", ["$http", "ENV",function ($http, ENV) {

	/**
	 * API
	 */
	var api = {
		RESOURCE_URI: "/manager/deposit-area/",
		addDepositArea: addDepositArea,
		deleteDepositAreaById: deleteDepositAreaById,
		getDepositAreaById: getDepositAreaById,
		editDepositArea: editDepositArea,
		getDepositAreaWithFilters: getDepositAreaWithFilters,
		importCsv: importCsv
	};


	/**
	 * Récupérer la zone dépôt pour l'id passé en paramètre
	 * @param id
	 * @returns {HttpPromise}
	 */
	function getDepositAreaById(id) {
		return $http.get(ENV.API_URL + api.RESOURCE_URI + id);
	}

	/**
	 * Récupérer toutes les zones de dépôts pour une compagnie.
	 * @returns {HttpPromise}
	 */
	function getDepositAreaWithFilters(postObject) {
		return $http.post(ENV.API_URL + api.RESOURCE_URI, postObject);
	}

	/**
	 * Mettre à jour une zone de dépôt.
	 * @param dp zone de dépôts à mettre à jour
	 * @returns {*|HttpPromise}
	 */
	function editDepositArea(dp) {
		var depositArea = formatDepositArea(dp);
		depositArea.id = dp.id;
		return $http.put(ENV.API_URL + api.RESOURCE_URI + dp.id, depositArea);
	}

	/**
	 * Supprimer une zone de dépôt.
	 *
	 * @param depositAreaId l'ID de la zone de dépôt à supprimer.
	 * @returns {HttpPromise|*|{display}}
	 */
	function deleteDepositAreaById(depositAreaId) {
		return $http.delete(ENV.API_URL + api.RESOURCE_URI + depositAreaId);
	}

	/**
	 * Ajouter une zone de dépôt.
	 * @param zone de dépôt à ajouter.
	 * @returns {*|HttpPromise}
	 */
	function addDepositArea(depositArea) {
		var newDepositArea = formatDepositArea(depositArea);
		return $http.put(ENV.API_URL + api.RESOURCE_URI, newDepositArea);
	}

	/**
	 * Import CSV
	 * TODO
	 * @param depositArea
	 * @returns {HttpPromise}
	 */
	function importCsv(depositArea) {
		/*var fd = new FormData();
		fd.append('file', driver.file);
		fd.append('companyId', driver.company.id);

		return $http.post(ENV.API_URL + api.RESOURCE_URI + 'import/csv', fd, {
			transformRequest: angular.identity,
			headers: {'Content-Type': undefined}
		});*/
	}

	/**
	 * Adapte la zone de dépôt pour correspondre à l'objet backend
	 * @param depositArea
	 * @returns {{name: *, adress: *, zip: *, city: *, lat: *, long: *, type: *,}}
	 */
	function formatDepositArea(depositArea) {
		return {
			"name": depositArea.name,
			"adress": depositArea.adress,
			"zip": depositArea.zip,
			"city": depositArea.city,
			"latitude": depositArea.latitude,
			"longitude": depositArea.longitude,
			"type": depositArea.type
		};
	}

	return api;

}]);
